export default __webpack_public_path__ + "static/media/01d-vid.0d361cd1.mp4";